import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { StorageService } from '../util/storage.service';
import { SessionStorageService } from '../util/session-storage.service';
import { Outlet } from '@app/shared/models/api-response/catalog-api-response';
import { PSLAResponse } from '@app/shared/models/api-response/psla-response';

@Injectable({
    providedIn: 'root'
})
export class PslaService {
    pslaNotification = new BehaviorSubject<any>({});

    constructor(
        private http: HttpClient,
        private storageService: StorageService,
        private sessionStorage: SessionStorageService
    ) {}

    fetchPSLAResponse() {
        const params: any = {
            lat: this.storageService.get('latitude') || 0,
            lon: this.storageService.get('longitude') || 0,
            outlet_id: this.storageService.get('outlet_id') || 1,
            service_type: this.storageService.get('service_type')
        };
        const headers = {
            'x-api-key': 'I2S1RTkPhc4J1hEGiSc3K3oZqO71joZa1xY1kn1Q'
        };
        return this.http.get<PSLAResponse>(`https://psla.box8.in/catalog/psla`, { params, headers });
    }

    async getPSLAdata(promotionalBannerPresent: boolean, outlet: Outlet | null = null) {
        if (outlet && !outlet.open) {
            this.pslaNotification.next({
                promotionalBannerPresent
            });
            return;
        }

        const pslaData = this.sessionStorage.get('psla_data') || {};
        const currentTime = Date.now();
        const expiryTimeInMS = pslaData.expires_at ? Number(pslaData.expires_at * 1000) : 0;

        if (!expiryTimeInMS || currentTime > expiryTimeInMS) {
            lastValueFrom(this.fetchPSLAResponse()).then(
                (response) => {
                    if (response.meta.code === 200) {
                        this.sessionStorage.set('psla_data', response);
                        this.pslaNotification.next({
                            ...response,
                            promotionalBannerPresent
                        });
                    } else {
                        const TEN_MINUTES = 60 * 10;
                        this.sessionStorage.set('psla_data', {
                            expires_at: Math.floor(currentTime / 1000) + TEN_MINUTES
                        });
                        this.pslaNotification.next({
                            promotionalBannerPresent
                        });
                    }
                },
                () => {
                    this.pslaNotification.next({
                        promotionalBannerPresent
                    });
                }
            );
        } else {
            this.pslaNotification.next({
                ...pslaData,
                promotionalBannerPresent
            });
        }
    }
}
